import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/politica-privacidade')({
  component: PoliticaPrivacidadePage,
});

function PoliticaPrivacidadePage() {
  return (
    <div className="min-h-screen bg-page-background p-6 md:p-10">
      <div className="mx-auto max-w-5xl rounded-lg border bg-card p-6 md:p-10">
        <header className="mb-8 space-y-2 border-b pb-6">
          <h1 className="text-3xl font-bold">ASSETO</h1>
          <p className="text-sm text-muted-foreground">
            Plataforma Interna de Gestao de Usuarios e Parceiros
          </p>
          <h2 className="text-xl font-semibold">Politica de Privacidade</h2>
          <p className="text-sm text-muted-foreground">
            Versao: 2.0 | Vigencia: 01 de junho de 2026 | Publico: Usuarios internos, parceiros
            cadastrados e usuarios de plataformas Meta (Facebook, Instagram, WhatsApp)
          </p>
          <p className="text-sm text-muted-foreground">
            Este documento descreve como o Asseto coleta, usa, armazena e protege os dados pessoais
            e de acesso na plataforma, incluindo dados obtidos por meio das APIs da Meta Platforms
            (Facebook, Instagram e WhatsApp Business).
          </p>
        </header>

        <main className="space-y-8 text-sm leading-7">
          <section className="space-y-3">
            <h3 className="text-lg font-semibold">PARTE I - POLITICA DE PRIVACIDADE</h3>

            <h4 className="font-semibold">1. Identificacao do Controlador de Dados</h4>
            <p>
              O Asseto e o controlador dos dados pessoais tratados nesta plataforma interna, nos
              termos da Lei Geral de Protecao de Dados (Lei n.o 13.709/2018 - LGPD).
            </p>
            <p className="font-medium">Encarregado de Protecao de Dados (DPO)</p>
            <p>
              Para duvidas, solicitacoes ou exercicio de direitos, entre em contato com o
              Encarregado de Protecao de Dados pelo e-mail: privacidade@asseto.com.br
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">2. Dados Pessoais Coletados</h4>
            <p className="font-medium">2.1 Dados de Usuarios Internos</p>
            <p>
              Ao acessar e utilizar a plataforma, os usuarios internos (colaboradores,
              administradores e gestores) tem os seguintes dados coletados:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Nome completo e cargo</li>
              <li>Endereco de e-mail corporativo</li>
              <li>Login e credenciais de acesso (senha armazenada em formato criptografado)</li>
              <li>Perfil e nivel de permissao na plataforma</li>
              <li>Registros de acesso (data, hora, IP e dispositivo)</li>
              <li>Acoes realizadas dentro da plataforma (logs de auditoria)</li>
            </ul>

            <p className="font-medium">2.2 Dados de Parceiros Cadastrados</p>
            <p>
              Os parceiros (pessoas fisicas ou juridicas) cadastrados na plataforma tem os
              seguintes dados registrados:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Nome ou razao social</li>
              <li>CPF ou CNPJ</li>
              <li>Dados de contato: e-mail, telefone e endereco</li>
              <li>
                Informacoes contratuais e documentos relacionados ao vinculo com o Asseto
              </li>
              <li>Status de cadastro e historico de interacoes</li>
              <li>
                Dados bancarios, quando necessarios para fins de pagamento (armazenados de forma
                segura)
              </li>
            </ul>

            <p className="font-medium">2.3 Dados Coletados via APIs da Meta (Facebook, Instagram e WhatsApp Business)</p>
            <p>
              Quando um cliente do Asseto conecta sua conta do Facebook, Instagram ou WhatsApp
              Business a plataforma, por meio das APIs oficiais da Meta Platforms, Inc., os
              seguintes dados podem ser coletados e armazenados:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Identificadores de conta (Page ID, Instagram User ID, Phone Number ID)</li>
              <li>Nome de exibicao e informacoes publicas do perfil da conta conectada</li>
              <li>Conteudo de mensagens diretas (DMs) recebidas e enviadas pela Pagina do Facebook, conta do Instagram ou numero do WhatsApp Business do cliente</li>
              <li>Metadados das mensagens: data, hora, tipo de midia e status de entrega/leitura</li>
              <li>Identificadores anonimizados dos usuarios finais que enviaram mensagens (IDs escopados pela Meta, nao contendo dados pessoais diretamente identificaveis)</li>
              <li>Tokens de acesso tecnicos necessarios para operar a integracao (armazenados de forma criptografada)</li>
            </ul>
            <p>
              Esses dados sao coletados exclusivamente em nome do cliente do Asseto (tenant) que
              autorizou a integracao, e sao utilizados unicamente para exibir e gerenciar as
              conversas dentro da plataforma do respectivo cliente.
            </p>

            <p className="font-medium">2.4 Dados Coletados Automaticamente</p>
            <p>
              A plataforma coleta automaticamente dados tecnicos para garantir a seguranca e o bom
              funcionamento do sistema:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Endereco IP e informacoes de rede</li>
              <li>Tipo de navegador e sistema operacional</li>
              <li>Paginas acessadas, tempo de sessao e acoes realizadas</li>
              <li>Logs de erros e eventos do sistema</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">3. Base Legal para o Tratamento</h4>
            <p>
              O tratamento dos dados pessoais realizado pelo Asseto fundamenta-se nas seguintes
              bases legais previstas na LGPD:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Execucao de contrato: tratamento necessario para gerenciar o relacionamento com
                parceiros e prestadores de servico.
              </li>
              <li>
                Interesse legitimo: monitoramento de seguranca, prevencao a fraudes e auditoria de
                acesso a plataforma.
              </li>
              <li>
                Cumprimento de obrigacao legal ou regulatoria: manutencao de registros exigidos por
                lei.
              </li>
              <li>
                Consentimento: quando aplicavel, para finalidades especificas que excedam o escopo
                contratual.
              </li>
            </ul>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">4. Finalidades do Tratamento de Dados</h4>
            <p>Os dados coletados sao utilizados exclusivamente para as seguintes finalidades:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Autenticar e autorizar o acesso de usuarios a plataforma</li>
              <li>Gerenciar o cadastro, o relacionamento e as interacoes com parceiros</li>
              <li>
                Garantir a seguranca e a integridade do sistema por meio de logs e auditorias
              </li>
              <li>Gerar relatorios gerenciais e indicadores operacionais</li>
              <li>Cumprir obrigacoes legais, regulatorias e contratuais</li>
              <li>Prevenir fraudes, abusos e acessos nao autorizados</li>
              <li>Melhorar continuamente a plataforma com base em dados anonimizados de uso</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">5. Compartilhamento de Dados</h4>
            <p>
              O Asseto nao vende, aluga ou cede dados pessoais a terceiros para fins comerciais. O
              compartilhamento de dados ocorre somente nas seguintes situacoes:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Prestadores de servicos tecnologicos (ex.: hospedagem, banco de dados) que atuam
                como operadores de dados, sujeitos a obrigacoes contratuais de confidencialidade e
                seguranca.
              </li>
              <li>
                Autoridades governamentais ou regulatorias, quando exigido por lei, ordem judicial
                ou determinacao legal.
              </li>
              <li>
                Parceiros de negocio, apenas na medida estritamente necessaria para execucao do
                contrato e com os devidos controles de acesso.
              </li>
            </ul>
            <p>
              Todos os terceiros que recebem dados pessoais do Asseto estao sujeitos a clausulas
              contratuais de protecao de dados alinhadas a LGPD.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">6. Retencao e Exclusao de Dados</h4>
            <p>
              Os dados pessoais sao retidos pelo prazo necessario para cumprir as finalidades
              descritas nesta politica ou conforme determinado por obrigacoes legais:
            </p>
            <div className="overflow-x-auto rounded-md border">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="border-b bg-muted/50">
                    <th className="p-3 font-medium">Categoria de Dado</th>
                    <th className="p-3 font-medium">Prazo de Retencao</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="p-3">Dados de acesso e logs</td>
                    <td className="p-3">Ate 5 anos apos o encerramento da conta ou vinculo</td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-3">Dados de parceiros</td>
                    <td className="p-3">Duracao do contrato + 5 anos (prazo prescricional civil)</td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-3">Dados de usuarios internos</td>
                    <td className="p-3">Vigencia do vinculo empregaticio + 5 anos</td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-3">Dados bancarios</td>
                    <td className="p-3">Conforme exigencia fiscal e contabil (ate 10 anos)</td>
                  </tr>
                  <tr>
                    <td className="p-3">Cookies de sessao</td>
                    <td className="p-3">Encerramento da sessao ou logout</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              Apos o encerramento dos prazos de retencao, os dados serao eliminados de forma segura
              ou anonimizados, de modo que nao seja possivel identificar o titular.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">7. Seguranca dos Dados</h4>
            <p>
              O Asseto adota medidas tecnicas e organizacionais adequadas para proteger os dados
              pessoais contra acesso nao autorizado, perda, alteracao ou divulgacao indevida,
              incluindo:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Criptografia de dados em transito (TLS/HTTPS) e em repouso</li>
              <li>Controle de acesso baseado em perfis e principio do minimo privilegio</li>
              <li>
                Autenticacao segura com politicas de senha e, quando aplicavel, autenticacao
                multifator (MFA)
              </li>
              <li>Logs de auditoria com registro de todas as acoes criticas na plataforma</li>
              <li>Testes periodicos de seguranca e analise de vulnerabilidades</li>
              <li>
                Politicas internas de confidencialidade para todos os colaboradores com acesso a
                plataforma
              </li>
            </ul>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">8. Direitos dos Titulares de Dados</h4>
            <p>
              Nos termos da LGPD, os titulares de dados pessoais tem os seguintes direitos, que
              podem ser exercidos mediante solicitacao ao DPO:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Confirmacao da existencia de tratamento de seus dados</li>
              <li>Acesso aos dados pessoais armazenados</li>
              <li>Correcao de dados incompletos, inexatos ou desatualizados</li>
              <li>
                Anonimizacao, bloqueio ou eliminacao de dados desnecessarios ou tratados em
                desconformidade com a LGPD
              </li>
              <li>Portabilidade dos dados a outro fornecedor, quando aplicavel</li>
              <li>Eliminacao dos dados pessoais tratados com base no consentimento</li>
              <li>Informacao sobre com quem os dados foram compartilhados</li>
              <li>Revogacao do consentimento, quando o tratamento for baseado nessa base legal</li>
            </ul>
            <p className="font-medium">Como exercer seus direitos</p>
            <p>
              Envie sua solicitacao para: privacidade@asseto.com.br
              <br />
              O Asseto responde a todas as solicitacoes em ate 15 dias uteis, conforme previsto na
              LGPD.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">9. Incidentes de Seguranca</h4>
            <p>
              Em caso de incidente de seguranca que possa acarretar risco ou dano relevante aos
              titulares de dados, o Asseto compromete-se a:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Notificar a Autoridade Nacional de Protecao de Dados (ANPD) em prazo razoavel,
                conforme exigido pela LGPD
              </li>
              <li>Comunicar os titulares afetados de forma clara e tempestiva</li>
              <li>
                Registrar o incidente, suas causas e as medidas adotadas para mitigacao e prevencao
              </li>
            </ul>
          </section>

          <section className="space-y-3 border-t pt-6">
            <h3 className="text-lg font-semibold">PARTE II - INTEGRACAO COM A META PLATFORMS</h3>

            <h4 className="font-semibold">10. Integracao com Facebook, Instagram e WhatsApp Business</h4>
            <p>
              O Asseto oferece, como funcionalidade opcional e contratavel, a integracao com as APIs
              oficiais da Meta Platforms, Inc. (doravante "Meta"), que permite aos clientes do Asseto
              gerenciar mensagens recebidas em suas Paginas do Facebook, contas do Instagram Business
              e numeros do WhatsApp Business diretamente na plataforma.
            </p>

            <h4 className="font-semibold">10.1 Autorizacao e Consentimento</h4>
            <p>
              A integracao com as plataformas da Meta e realizada exclusivamente mediante autorizacao
              expressa do cliente (titular da conta Meta). O processo de autorizacao segue o protocolo
              OAuth 2.0 oficial da Meta, no qual o cliente:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>E redirecionado ao ambiente seguro da Meta para realizar o login e conceder permissoes</li>
              <li>Seleciona quais Paginas, contas ou numeros deseja conectar ao Asseto</li>
              <li>Tem total controle sobre o escopo de acesso concedido</li>
            </ul>
            <p>
              O Asseto nao coleta credenciais de acesso (usuario e senha) das contas Meta dos clientes.
              Todo o acesso e realizado por meio de tokens de acesso emitidos pela propria Meta, com
              prazo de validade definido.
            </p>

            <h4 className="font-semibold">10.2 Finalidade dos Dados Obtidos via Meta</h4>
            <p>
              Os dados obtidos por meio das APIs da Meta sao utilizados exclusivamente para:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Exibir mensagens recebidas nos canais conectados dentro do painel do cliente no Asseto</li>
              <li>Permitir que os operadores do cliente respondam a mensagens diretamente pela plataforma</li>
              <li>Armazenar o historico de conversas para consulta interna do cliente</li>
              <li>Gerar metricas e relatorios de atendimento para uso exclusivo do cliente</li>
            </ul>
            <p className="font-semibold text-destructive">
              O Asseto NAO utiliza dados obtidos via APIs da Meta para fins publicitarios, nao os
              vende, nao os cede a terceiros para fins comerciais e nao os utiliza para direcionar
              anuncios de qualquer natureza.
            </p>

            <h4 className="font-semibold">10.3 Compartilhamento de Dados com a Meta</h4>
            <p>
              Ao utilizar os servicos do Asseto com integracao Meta ativa, os dados de mensagens
              trafegam pelos servidores da Meta antes de chegarem ao Asseto, conforme o funcionamento
              tecnico das APIs (webhooks). O tratamento de dados pela Meta e regido pela propria
              Politica de Dados da Meta, disponivel em:{' '}
              <a
                href="https://www.facebook.com/privacy/policy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-primary"
              >
                facebook.com/privacy/policy
              </a>.
            </p>

            <h4 className="font-semibold">10.4 Revogacao do Acesso</h4>
            <p>
              O cliente pode revogar o acesso do Asseto as suas contas Meta a qualquer momento por
              dois caminhos:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                <span className="font-medium">Pelo Asseto:</span> acessando Configuracoes → Omnicanal → Canais Conectados → Desconectar canal
              </li>
              <li>
                <span className="font-medium">Diretamente pela Meta:</span> acessando as Configuracoes da Pagina do Facebook ou do Aplicativo em{' '}
                <a
                  href="https://www.facebook.com/settings?tab=business_tools"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-primary"
                >
                  facebook.com/settings → Aplicativos e Sites
                </a>{' '}
                e removendo o acesso do aplicativo Asseto
              </li>
            </ul>
            <p>
              Apos a revogacao, o Asseto cessa imediatamente a coleta de novos dados. Os dados
              historicos ja armazenados serao retidos pelo prazo contratual e excluidos conforme
              a politica de retencao descrita na Secao 6.
            </p>

            <h4 className="font-semibold">10.5 Conformidade com as Politicas da Meta</h4>
            <p>
              O Asseto opera em conformidade com as Politicas de Uso da Plataforma da Meta
              (Meta Platform Terms), os Termos do Desenvolvedor e as diretrizes especificas de
              cada produto (Messenger, Instagram Graph API, WhatsApp Business Platform). O acesso
              as APIs da Meta e realizado por meio de aplicativo registrado e submetido ao processo
              de revisao (App Review) da Meta.
            </p>

            <h4 className="font-semibold">11. Dados de Usuarios Finais (Contatos dos Clientes)</h4>
            <p>
              Os usuarios finais que interagem com as Paginas, contas ou numeros de WhatsApp dos
              clientes do Asseto (ex.: pessoas que enviam mensagens para uma empresa que usa o Asseto)
              tem seus dados tratados nos seguintes termos:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Os identificadores desses usuarios sao fornecidos pela Meta em formato anonimizado e escopado (nao revelam dados pessoais diretamente identificaveis ao Asseto)</li>
              <li>O conteudo das mensagens e armazenado em nome do cliente do Asseto, que e o responsavel pelo atendimento e pela relacao com seus proprios usuarios finais</li>
              <li>O Asseto atua como operador de dados nessa relacao; o cliente do Asseto e o controlador responsavel por garantir a base legal para o tratamento das mensagens de seus usuarios finais</li>
              <li>Usuarios finais que desejam exercer direitos sobre seus dados devem contatar diretamente a empresa (cliente do Asseto) com a qual se comunicaram</li>
            </ul>

            <h4 className="font-semibold">12. Seguranca dos Tokens de Acesso Meta</h4>
            <p>
              Os tokens de acesso emitidos pela Meta e armazenados pelo Asseto sao protegidos por
              criptografia em repouso e em transito. O acesso a esses tokens e restrito aos sistemas
              internos do Asseto estritamente necessarios para operar a integracao, e nao e exposto
              a usuarios humanos da plataforma.
            </p>

            <h4 className="font-semibold">13. Contato para Questoes Relacionadas a Meta</h4>
            <p>
              Para questoes especificas sobre o tratamento de dados obtidos via APIs da Meta, o
              titular pode contatar o DPO do Asseto pelo e-mail:{' '}
              <a href="mailto:contato@digitalfluxo.com" className="underline text-primary">
                contato@digitalfluxo.com
              </a>
            </p>
          </section>

          <section className="space-y-3 border-t pt-6">
            <h3 className="text-lg font-semibold">PARTE III - DISPOSICOES GERAIS</h3>

            <h4 className="font-semibold">14. Atualizacoes desta Politica</h4>
            <p>
              Esta politica pode ser atualizada periodicamente para refletir mudancas nos processos
              internos, na legislacao aplicavel ou nas funcionalidades da plataforma. Alteracoes
              relevantes serao comunicadas aos usuarios por meio de notificacao dentro da propria
              plataforma e/ou por e-mail corporativo, com antecedencia minima de 15 dias uteis. A
              versao vigente estara sempre disponivel na plataforma, com a data da ultima
              atualizacao indicada no cabecalho deste documento.
            </p>

            <h4 className="font-semibold">15. Legislacao e Foro Aplicaveis</h4>
            <p>
              Esta politica e regida pela legislacao brasileira, em especial pela Lei Geral de
              Protecao de Dados (Lei n.o 13.709/2018 - LGPD) e demais normas aplicaveis. Qualquer
              controversia decorrente desta politica sera submetida ao foro da comarca de Belem,
              Estado do Para, com exclusao de qualquer outro, por mais privilegiado que seja.
            </p>

            <h4 className="font-semibold">16. Canal de Contato e DPO</h4>
            <p>
              Para exercicio de direitos, esclarecimentos, reclamacoes ou qualquer comunicacao
              relacionada a privacidade e protecao de dados, o titular pode contatar o Encarregado
              de Protecao de Dados (DPO) do Asseto:
            </p>
            <p>
              DPO - Encarregado de Protecao de Dados | Asseto
              <br />
              E-mail: contato@digitalfluxo.com
              <br />
              Horario de atendimento: segunda a sexta, das 9h as 18h (horario de Brasilia)
              <br />
              Prazo de resposta: ate 15 dias uteis a contar do recebimento da solicitacao
            </p>
          </section>
        </main>

        <footer className="mt-10 border-t pt-6 text-sm text-muted-foreground">
          <p>Asseto - Plataforma de Gestao e Comunicacao para Empresas</p>
          <p>Vigencia: 01 de junho de 2026 | Versao 2.0</p>
          <div className="mt-4 flex gap-4">
            <Link to="/termos-de-uso" className="underline">Termos de Uso</Link>
            <Link to="/politica-cookie" className="underline">Politica de Cookies</Link>
            <Link to="/exclusao-de-dados" className="underline">Exclusao de Dados</Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
